import React, { Component } from 'react';
import { connect } from 'react-redux';
import PerformanceRankSlot from '../PerformanceRankSlot';
import API_URL from '../../../common/url';
import ExportModal from './ExportModal';
import Filter from './Filter';
import '../style/home.less';
import { saveSearchParams } from '../../../actions/rankActions';

class PerformanceRank extends Component {
    render() {
        return (
            <PerformanceRankSlot
                {...this.props}
                detailName="CRC"
                pathName="performanceDetail"
                detailUrl={API_URL.home.queryPerformanceTable}
                filterProps={
                    (maxDate, search, exportFunc, searchParams) => (
                        <Filter
                            maxDate={maxDate}
                            search={search}
                            export={exportFunc}
                            searchParams={searchParams}
                        />
                    )
                }
                exportProps={
                    (visible, pagination, searchParams, changeVisible) => {
                        return (
                            <ExportModal
                                visible={visible}
                                pagination={pagination}
                                searchParams={searchParams}
                                changeVisible={changeVisible}
                            />
                        )
                    }
                }
            />
        )
    }
}

const mapSateToProps = (state) => ({
    performanceState: state.rankState.params || {},
});

const mapDispatchToProps = (dispatch) => ({
    saveParams: (params) => dispatch(saveSearchParams(params))
})

export default connect(mapSateToProps, mapDispatchToProps)(PerformanceRank);


// WEBPACK FOOTER //
// ./src/components/home/performanceRank/index.js